import moment from 'moment';
import * as React from 'react';
import { Table } from 'reactstrap';
import { mergeClasses } from '../constants';
import './Calendar.scss';

export type Day = {
  moment: moment.Moment | null;
  className: string | null;
};

type CalendarDayProps = {
  day: Day;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
};

export class CalendarDay extends React.PureComponent<CalendarDayProps> {
  render() {
    const { day, onClick, onMouseEnter, onMouseLeave, ...rest } = this.props;
    const handlers = day.moment
      ? {
          onClick,
          onMouseEnter,
          onMouseLeave,
          'data-date': day.moment.format('YYYYMMDD'),
        }
      : {};
    return (
      <td {...rest}>
        <div className={day.className || undefined} {...handlers}>
          {day.moment ? day.moment.format('D') : '-'}
        </div>
      </td>
    );
  }
}

export type Week = Array<Day>;

type Props = {
  title: React.ReactNode;
  className?: string;
  weeks: Array<Week>;
  onDayClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onDayMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
  onDayMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
};

export default class Calendar extends React.PureComponent<Props> {
  render() {
    const {
      className,
      weeks,
      title,
      onDayClick,
      onDayMouseLeave,
      onDayMouseEnter,
    } = this.props;
    return (
      <div className={mergeClasses(['calendar', className])}>
        {title}
        <Table>
          <tbody>
            <tr>
              <th>Su</th>
              <th>Mo</th>
              <th>Tu</th>
              <th>We</th>
              <th>Th</th>
              <th>Fr</th>
              <th>Sa</th>
            </tr>
            {weeks.map((week, index) => (
              <tr key={index}>
                {week.map((day: Day, index: number) => (
                  <CalendarDay
                    key={index}
                    day={day}
                    onClick={onDayClick}
                    onMouseEnter={onDayMouseEnter}
                    onMouseLeave={onDayMouseLeave}
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}
